// import { io } from "socket.io-client";

// export const connectSocket = () => {
//   return io("http://localhost:5050", {
//     transports: ["websocket"],
//   });
// };

// import { io } from "socket.io-client";

// // If we're running on localhost (React dev server), use port 5050.
// // Otherwise, connect back to the same origin that served the page.
// const SOCKET_URL =
//   window.location.hostname === "localhost"
//     ? "http://localhost:5050"
//     : window.location.origin;

// export function connectSocket() {
//   return io(SOCKET_URL, {
//     path: "/socket.io",
//     transports: ["websocket"],
//   });
// }

// src/socket.js
// import { io } from "socket.io-client";

// const isLocal = window.location.hostname === "localhost";
// const backendFromEnv = process.env.REACT_APP_BACKEND_URL;

// // if env var is set, use it, otherwise if localhost use 5050, else
// // fall back to window.location.origin (should never happen in prod)
// let SOCKET_BASE_URL = backendFromEnv
//   ? backendFromEnv.replace(/\/$/, "")    // drop trailing slash
//   : isLocal
//   ? "http://localhost:5050"
//   : window.location.origin;

// // convert http→ws and https→wss automatically
// if (SOCKET_BASE_URL.startsWith("http")) {
//   SOCKET_BASE_URL = SOCKET_BASE_URL.replace(/^http/, "ws");
// }

// export function connectSocket() {
//   return io(SOCKET_BASE_URL, {
//     path: "/socket.io",
//     transports: ["websocket"],
//     secure: SOCKET_BASE_URL.startsWith("wss"),
//   });
// }

// src/socket.js
import { io } from "socket.io-client";
import { ensureFreshAccessToken, getStoredAccessToken } from "./utils/auth";

// For local development, default to port 8000 where the backend is running
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

let SOCKET_URL;
if (process.env.REACT_APP_BACKEND_URL) {
  SOCKET_URL = process.env.REACT_APP_BACKEND_URL;
} else if (isLocalhost) {
  // Default to backend port 8000 for local development
  SOCKET_URL = "http://localhost:8000";
} else {
  // For production, use the same origin (HTTPS)
  // This assumes nginx is proxying both frontend and backend
  SOCKET_URL = window.location.origin;
}

console.log("🔌 Connecting to Socket.IO server at:", SOCKET_URL);
console.log("🌍 Current hostname:", window.location.hostname);
console.log("🔧 Is localhost:", isLocalhost);

// Exported so other direct-connection hooks (e.g. useZoomBridgeSocket, since
// the RTMS bridge folded into this same backend) resolve the same URL
// without duplicating this localhost/prod fallback logic.
export { SOCKET_URL };

// Upper bound on the pre-handshake token refresh. Long enough for a real round
// trip, short enough that a stalled auth service delays a connect rather than
// preventing one.
const AUTH_REFRESH_TIMEOUT_MS = 4000;

export function connectSocket() {
  return io(SOCKET_URL, {
    path: "/socket.io",
    transports: ["polling", "websocket"], // Start with polling (works behind self-signed/IP cert), upgrade to websocket when the cert matches (domain access)
    timeout: 120000, // 2 minutes timeout
    // Send the Cognito access token on every connect / reconnect so the
    // server can resolve the user's identity without trusting client
    // payloads.  Using the function form ensures each reconnect picks up a
    // freshly-refreshed token rather than a stale closure capture.
    auth: async (cb) => {
      // Per attempt, not per socket: reconnects re-enter this callback and a
      // shared handle would let one attempt clear another's timer.
      let refreshTimer = null;
      // Refresh BEFORE handshaking rather than sending whatever is in storage.
      // An expired token here makes the server resolve the socket as anonymous,
      // and the session-ownership guard then answers tse:access_denied — which is
      // how refreshing a copilot page an hour into a call threw the engineer onto
      // a blank chat.
      try {
        await Promise.race([
          ensureFreshAccessToken(),
          // `fetch` has NO default timeout, so a hung refresh endpoint would park
          // this callback indefinitely — see the finally below for why that is
          // fatal. Cap it and connect with the stale token instead; a denial is
          // recoverable, a socket that never handshakes is not.
          new Promise((resolve) => { refreshTimer = setTimeout(resolve, AUTH_REFRESH_TIMEOUT_MS); }),
        ]);
      } catch {
        // Deliberately empty — the finally still connects.
      } finally {
        if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null; }
        // cb MUST run exactly once on every path. socket.io-client sends the
        // CONNECT packet only when this fires and applies no timeout of its own,
        // so skipping it leaves the transport open with neither `connect` nor
        // `connect_error` — a dead page with nothing to report. Hence: the sole
        // call site, in a finally.
        cb({ token: getStoredAccessToken() });
      }
    },
    // A copilot session must outlive its socket: the server keeps the session
    // alive for 24h and rebinds it on rejoin, so the only job here is to keep
    // trying forever rather than give up after socket.io's default 5 attempts
    // and leave the page connected to nothing.
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
  });
}

